<template lang="pug">
    .z-select(v-bind:class="classes")
        .z-select-container
            label(v-if="$props.label" v-bind:for="$props.id" v-html="($props.label + (($props.required) ? '<span>*</span>' : '') + ($props.readonly ? ' (только для чтения)' : '') + ($props.loading ? ' (загрузка)' : ''))")
            .z-select__input-container
                select(
                    v-model="val"
                    v-bind:id="$props.id"
                    v-bind:name="$props.name"
                    v-bind:required="$props.required"
                    v-bind:disabled="$props.disabled"
                    v-bind:readonly="$props.readonly"
                    v-on:focus="onFocus"
                    v-on:blur="onBlur"
                    v-on:change="change"
                )
                    slot
                i.z-select__arrow
                    svg(height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg")
                        path(d="M7 10l5 5 5-5z")
                        path(d="M0 0h24v24H0z" fill="none")
        span.z-error(v-if="error") {{error}}
</template>
<script>
    export default {
        name: 'z-select',
        components: {},
        props: {
            id: {
                type: String,
                default: 'z-input'
            },
            name: {
                type: String,
                default: 'z-input'
            },
            label: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            error: {
                type: String,
                default: ''
            },
            value: {
                type: [String, Number],
                default: () => ''
            },
            inline: {
                type: Boolean,
                default: false
            },
            noMargin: {
                type: Boolean,
                default: false
            },
            dirty: {
                type: Boolean,
                default: false
            },
            light: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                isDirty: false,
                focus: false,
                val: ''
            }
        },
        created() {
            if (this.$props.value) this.val = this.$props.value;
        },
        watch: {
            'value'(value) {
                if (this.val != value) this.val = value;
            },
            'val'(val) {
                //this.change();
            },
            '$props.dirty'(val) {
                if (val && this.isDirty !== val) this.emitDirty();
            }
        },
        computed: {
            classes() {
                return {                    
                    'no-label' : (this.$props.label ? false : true),
                    'has-value': (this.$props.value || this.$props.value === 0),
                    'has-error': (this.error && this.error.length),
                    'focus':     this.focus,
                    'is-dirty':  this.isDirty,
                    'disabled':  this.$props.disabled,
                    'readonly':  this.$props.readonly,
                    'inline':    this.$props.inline,
                    'no-margin': this.$props.noMargin,
                    'light':     this.$props.light
                };
            }
        },
        methods: {
            onFocus(e) {
                this.focus = true;
                this.$emit('focus', e);
            },
            onBlur(e) {
                this.focus = false;
                this.$emit('blur', e);
            },
            change() {
                this.$emit('change', this.val);
                this.$emit('input', this.val);
                this.emitDirty();
            },
            emitDirty() {
                this.isDirty = true;
                this.$emit('update:dirty', this.isDirty);
            },
        }
    }
</script>
<style lang="sass">
    .z-select
        margin: 4px 0 10px 0
        width: 100%
        &.no-margin
            margin: 0
        .z-select-container
            padding: 4px 0 10px 0
            position: relative
        .z-error
            display: block
            height: auto
            min-height: 15px
            font-size: 11px
            line-height: 11px
            padding-top: 2px
            color: #ff1744
        label
            display: block
            color: rgba(0, 0, 0, 0.54)
            font-size: 12px
            font-weight: 500
            line-height: 12px
            transition: .4s cubic-bezier(.25,.8,.25,1)
            transition-duration: .3s
            z-index: 5
            resize: none
            margin-bottom: 3px
            span
                color: #D66565
        select
            font-size: 12px
            line-height: 24px
            border: none
            background: transparent
            outline: none
            color: #000
            font-weight: 400
            height: 26px
            width: 100%
            position: relative
            z-index: 10
            -webkit-appearance: none
            -moz-appearance:    none
            appearance:         none

        &.light
            select
                padding: 0 10px
                background: var(--color-secondary-100)
                color: var(--color-secondary-900)
            .z-select__input-container                
                &::before, &::after
                    display: none
        .error
        .z-select__input-container
            position: relative
            &::before
                content: ''
                position: absolute
                bottom: 0
                right: 0
                left: 0
                z-index: 1
                height: 2px
                opacity: 0
                transform: scaleX(.12)
                background-color: #2196f3
                transition: .3s cubic-bezier(.4,0,.2,1)
            &::after
                content: ''
                position: absolute
                bottom: 0
                right: 0
                left: 0
                z-index: 1
                transition: border .3s cubic-bezier(.4,0,.2,1),opacity .3s cubic-bezier(.4,0,.2,1),-webkit-transform 0s cubic-bezier(.4,0,.2,1) .3s
                will-change: border,opacity,transform
                background-color: #C4C4C4
                height: 1px
            .z-select__arrow
                position: absolute
                z-index: 1
                direction: ltr
                font-family: Material Icons
                width: 24px
                min-width: 24px
                height: 24px
                font-size: 24px !important
                margin: auto
                right: 0
                top: calc((32px - 24px) / 2)
    .z-select.no-label
        .z-select-container
            padding: 0
    .z-select.has-error
        label   
            color: #ff1744
        .z-select-container
            &::after
                background-color: #ff1744
            &::before
                background-color: #ff1744
    .z-select.focus
        .z-select__input-container
            &::after
                background-color: #2196f3
            &::before
                opacity: 1
                transform: scaleX(1)
                transition-property: border,opacity,transform,-webkit-transform
                background-color: #2196f3
    .z-select.disabled
        select
            background: #eaeaea
    .z-select.readonly
        select
            background: #eaeaea      
    .z-select.inline
        .z-select-container
            display: flex
            align-items: center
            padding: 0
            .z-select__input-container
                flex-grow: 1
        label
            width: 40%
            flex: 0 0 40%
            padding-right: 8px
            margin: 0 
    .z-select.is-dirty
        label
            color: #2196f3
</style>


// WEBPACK FOOTER //
// ZSelect.vue?3e0a4912